document.addEventListener('DOMContentLoaded', () => {
  // Conditional hide/show logic for form fields
  const radioInputs = document.querySelectorAll(
    '.form-group input[type=radio]'
  );

  radioInputs.forEach((radioInput) => {
    radioInput.addEventListener('click', (event) => {
      const closestFormGroup = event.target
        .closest('.form-group')
        .querySelector('.toggle-conditional-field');
      const conditionalRequiredField = event.target
        .closest('.form-group')
        .querySelector('.js-conditional-required');

      if (event.target.dataset.toggleConditionalField === 'true') {
        closestFormGroup.style.display = 'block';
        conditionalRequiredField.required = true;
      } else {
        closestFormGroup.style.display = 'none';
        conditionalRequiredField.required = false;
        conditionalRequiredField.value = '';
      }
    });
  });
});
